export default {
    init() {

        let vetForm = jQuery(".vetForm");

        if (vetForm.length)
        {
            setTimeout(() => {
                $('body,html').animate({
                    scrollTop: $("#requestAppointment").offset().top - 120
                }, 2000);  
            }, 300);
        }
      
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/vet.js